const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    marginLeft: 0,
    textAlign: 'center',
    width: '100%',
  },
  error: {
    color: theme.palette.secondary.dark,
    fontWeight: 500,
    margin: theme.spacing.unit,
    marginLeft: 0,
  },
  formControl: {
    margin: theme.spacing.unit,
    marginLeft: 0,
    minWidth: '100%',
  },
  header: {
    marginTop: 20,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  textArea: {
    marginHorizon: 0,
    marginVertical: 20,
  },
});

export default styles;
